import React, { useCallback, useState, useRef, useEffect } from 'react';
import axios from '../axios';
import ModalConfirm from '../modal/hooks/modal_comfirm';
import FeedItem from './feed_item';

// 使われていない

const FeedList = ({
  currentUser,
  userfeeds,
  loadNextList,
  isLoadingNextList,
  isLastPage,
}) => {
  const [userFeedList, setUserFeedList] = useState(userfeeds);
  const [friendsFullnames, setFriendsFullnames] = useState([]);
  const [deleteFeedId, setDeleteFeedId] = useState(null);
  const confirmModalRef = useRef(null);
  const ancLastItemRef = useRef(null);
  const isEnableNextLoad = useRef(true);

  useEffect(() => {
    setUserFeedList(userfeeds);
  }, [userfeeds]);

  const openConfirmModal = useCallback(
    (id) => {
      setDeleteFeedId(id);
      confirmModalRef.current.openModal();
    },
    [setDeleteFeedId, confirmModalRef]
  );

  const handleDeleteButton = useCallback(() => {
    if (!deleteFeedId) {
      return;
    }
    axios
      .delete('/api/userfeeds', { data: { userfeed_id: deleteFeedId } })
      .then(() => {
        setUserFeedList((prev) =>
          prev.filter((feed) => feed.id != deleteFeedId)
        );
      })
      .finally(() => {
        setDeleteFeedId(null);
      });
  }, [deleteFeedId, setUserFeedList]);

  const friends_fullnames = useCallback(() => {
    axios.get(`/api/user/friends/fullnames`).then((res) => {
      setFriendsFullnames((prev) => [...prev, ...res.data]);
    });
  }, []);

  useEffect(() => {
    friends_fullnames();
  }, []);

  const handleScrollEvent = useCallback(() => {
    const ancPosition = ancLastItemRef.current.offsetTop;
    const scrolled = $(window).scrollTop();
    if (
      scrolled > ancPosition - 1000 &&
      scrolled < ancPosition &&
      isEnableNextLoad.current
    ) {
      isEnableNextLoad.current = false;
      loadNextList();
    }
  }, [ancLastItemRef, isEnableNextLoad, loadNextList]);

  useEffect(() => {
    if (isLoadingNextList) {
      isEnableNextLoad.current = false;
    } else {
      isEnableNextLoad.current = true;
    }

    if (typeof window !== 'undefined') {
      if (isLastPage) {
        window.removeEventListener('scroll', handleScrollEvent);
      } else {
        window.addEventListener('scroll', handleScrollEvent);
      }

      return () => {
        window.removeEventListener('scroll', handleScrollEvent);
      };
    }
  }, [isLastPage, handleScrollEvent]);

  return (
    <React.Fragment>
      <div className="container col-lg-6">
        <div className="row">
          {userFeedList.map((userFeed) => (
            <FeedItem
              key={userFeed.id}
              currentUser={currentUser}
              userFeed={userFeed}
              friendsFullnames={friendsFullnames}
              openConfirmModal={(id) => openConfirmModal(id)}
            />
          ))}
          {isLoadingNextList ? (
            <div className="text-center pt-4">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            ''
          )}
          <div id="ancLastItem" ref={ancLastItemRef} />
        </div>
      </div>
      <ModalConfirm
        ref={confirmModalRef}
        title="フィードの削除"
        content="よろしいですか？"
        approveFunc={() => handleDeleteButton()}
        rejectFunc={() => setDeleteFeedId(null)}
      />
    </React.Fragment>
  );
};

export default FeedList;
